import { EntityModel } from '@/interfaces'
import {
  ALL_CATEGORIES_QUERY,
  CREATE_CATEGORY_MUTATION,
  DELETE_CATEGORY_MUTATION,
  FORCE_DELETE_CATEGORY_MUTATION,
  SINGLE_CATEGORY_QUERY,
  UPDATE_CATEGORY_MUTATION,
} from './graphql'
import cmsPageEntity from '@/entities/cmsPage/entity'
import elementSeoSettingsEntity from '@/entities/elementSeoSettings/entity'

const cmsCategoryModel: EntityModel = {
  name: 'category',
  namePlural: 'categories',
  uniqueName: 'cmsCategory',
  uniqueNamePlural: 'cmsCategories',
  path: 'cms/category',
  baseUrl: '/cms/categories',
  translationPrefix: 'entities:cmsCategory.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_CATEGORIES_QUERY,
    getSingle: SINGLE_CATEGORY_QUERY,
    create: CREATE_CATEGORY_MUTATION,
    update: UPDATE_CATEGORY_MUTATION,
    delete: DELETE_CATEGORY_MUTATION,
    forceDelete: FORCE_DELETE_CATEGORY_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:cmsCategory.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    pages: {
      name: 'pages',
      label: 'entities:cmsCategory.attributes.pages.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    seoSettings: {
      name: 'seoSettings',
      label: 'entities:cmsCategory.attributes.seoSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return elementSeoSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsCategoryModel
